import { render, staticRenderFns } from "./BsSideDrawer.vue?vue&type=template&id=c31fe2d0&"
import script from "./BsSideDrawer.vue?vue&type=script&lang=js&"
export * from "./BsSideDrawer.vue?vue&type=script&lang=js&"
import style0 from "./BsSideDrawer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports